import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_AS_AUTHENTICATED,
  USER_DATA,
  OTP,
  RESTART_OTP,
  ADD_VISITOR,
  FAILED,
  REMOVE_VISITOR,
  UPDATE_VISITOR
} from "../actions/types";

const initialState = {
  user: undefined,
  AuthToken: undefined,
  refreshToken: undefined,
  isAuthenticated: false,
  registerSuccess: false,
  Name: undefined,
  otp: false,
  errorMsg : '',
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_AS_AUTHENTICATED:
      localStorage.setItem("token", payload);
      //localStorage.setItem("AuthToken", payload);
      return {
        ...state,
        AuthToken: payload, // puts token in state
        isAuthenticated: true,
      };
    case OTP:
      /* ★★ C2a — `otp` נשאר **בוליאני** בכוונה: מסכים אחרים בודקים אותו
         כדגל ("האם שלב-הקוד פתוח"), והחלפתו באובייקט הייתה משנה התנהגות
         במקומות שלא נגענו בהם. במקום זה מוסיפים שני שדות נפרדים.
         ⚠️ זה היה הבאג: השרת החזיר `channel`/`to`, אבל ה-reducer זרק את
            כל המטען ושמר `true` — ולכן מסך-הקוד תמיד הציג "נשלח ב-SMS"
            גם כשהקוד באמת נשלח למייל. */
      return {
        ...state,
        otp: true,
        otpChannel: (payload && payload.channel) || 'sms',
        otpTo: (payload && payload.to) || '',
        errorMsg: '',
      };
    case RESTART_OTP:
      return {
        ...state,
        otp: false,
        otpChannel: 'sms',
        otpTo: '',
        errorMsg: payload.errorMsg
      };
    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.token);
     
      localStorage.setItem("FirstName", payload.FirstName);
      localStorage.setItem("LastName", payload.LastName);
      return {
        ...state,
        AuthToken: payload.token, // puts token in state
        isAuthenticated: true,
        FirstName: payload.FirstName,
        LastName: payload.LastName,
        user: payload,
        errorMsg: '',
      };
    case LOGIN_FAIL:
      return {
        ...state, 
        errorMsg : payload.errorMsg
      }
    case LOGOUT:
      localStorage.removeItem("token");
     
      localStorage.removeItem("Name");
      return {
        ...state,
        AuthToken: null,
        isAuthenticated: false,
        user: null,
        errorMsg: '',
      };
    case USER_DATA:
      return {
        ...state,
        user: payload,
      };
    case ADD_VISITOR:
      return {
        ...state,
        user: {...state.user, visitors: [...state.user.visitors, payload]},
      };
       case FAILED:
      return {
        ...state,
        user: {...state.user, visitors: [...state.user.visitors, payload]},
      };
      case UPDATE_VISITOR:
        console.log(payload)
      return {
        ...state,
        user: {...state.user, visitors: state.user.visitors.map(v => v.id == payload.id ? payload : v)},
      }
      case REMOVE_VISITOR:
        return {
          ...state,
          user : {...state.user, visitors: state.user.visitors?.filter(v => v.id !=  payload)},
        }
    default:
      return {
        ...state,      
        FirstName: localStorage.getItem("FirstName"),
        LastName: localStorage.getItem("LastName"),
      };
  }
};

export default authReducer;
